import Reveal from "@/components/feature/Reveal";
import { LINKS } from "@/constants/site";
import { sandoItems } from "@/mocks/sando";

export default function Sando() {
  return (
    <section className="w-full bg-cream py-14 md:py-24">
      <div className="mx-auto w-full max-w-5xl px-4 md:px-6">
        <Reveal className="text-center">
          <h2 className="font-serif text-3xl text-darktext md:text-5xl">
            También en CLEM: Sando
          </h2>
          <p className="mt-3 font-serif text-xl italic text-darktext/80 md:text-2xl">
            Tradición entre panes
          </p>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2">
          {sandoItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 100}>
              <article className="flex h-full flex-col overflow-hidden rounded-xl2 border border-darktext/10 bg-[#fffaf4]">
                <div className="aspect-[16/10] w-full overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.name} de Sando by Cerón`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="flex flex-1 flex-col p-5 md:p-6">
                  <h3 className="font-serif text-2xl text-darktext">{item.name}</h3>
                  <p className="mt-1 text-base font-bold text-darktext">{item.price}</p>
                  <p className="mt-3 text-base leading-relaxed text-darktext/75">
                    {item.description}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-10 flex justify-center">
          <a
            href={LINKS.instagramSando}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 whitespace-nowrap text-base font-semibold text-darktext underline decoration-malva decoration-2 underline-offset-4 transition-colors hover:text-malva"
          >
            <i className="ri-instagram-line text-xl" aria-hidden="true" />
            Conoce Sando en @sandobyceron
          </a>
        </Reveal>
      </div>
    </section>
  );
}